/**
 * @fileoverview POST handler for the "/users/subscription_groups/:id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { usersSubscriptionGroupsIdCacheKeys } from "./constants";
import type { PostUsersSubscriptionGroupsIdProps, UsersSubscriptionGroupsIdResult } from "./types";

export const postUsersSubscriptionGroupsId = reactQueryMutationAdapter(
  usersSubscriptionGroupsIdCacheKeys,
  (props: PostUsersSubscriptionGroupsIdProps): Promise<UsersSubscriptionGroupsIdResult> => {
    return fetch(`/users/subscription_groups/${props.id || ""}`, "POST", props);
  }
);
